module.exports = __webpack_public_path__ + "img/ytk_m5.0767820a.png";